import BondDetailsView from '@components/BondDirectoryFeature/feature/BondDetails';
import formatBondDetails from '@components/BondDirectoryFeature/feature/BondDetails/utils/helper';
import { configurationEntityTypes } from '@helpers/enums/configuration-enums';
import { HeadTagData } from '@helpers/headTagData';
import { isinRegexPattern } from '@helpers/regex-patterns';
import { isValidResponseEntity } from '@helpers/utils';
import { getBondDetailsById } from '@services/bond-details.service';
import { getOpenConfigurations } from '@services/configuration.service';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import { useEffect, useState } from 'react';
import texts from '@components/BondDirectoryFeature/feature/BondDetails/en.json';
import routes from '@helpers/routes';
import { isUnauthorizedRequest } from '@services/identity.service';

const BondDetailsPage = ({ isin, bondDetails }) => {
    const [isFromGoogle, setIsFromGoogle] = useState(null);

    useEffect(() => {
        if (document.referrer.includes('google.com')) {
            setIsFromGoogle(true);
        } else {
            setIsFromGoogle(false);
        }
    }, []);

    return (
        <>
            <NextHeadTag
                title={`${bondDetails?.isin} - ${bondDetails?.issuer}`}
                metaDesc={`Discover essential information about bond ISIN ${bondDetails?.isin} on Jiraaf's Bond Directory. Explore issuer details, coupon rate, maturity, and more`}
                canonicalUrl={`${process.env.NEXT_PUBLIC_APP_URL}${routes.bonds.byIsin(bondDetails?.isin)}`}
                {...HeadTagData[routes.bonds.baseIsin]}
            />
            <BondDetailsView
                id={isin}
                bondDetailsResponse={bondDetails}
                isFromGoogle={isFromGoogle}
            />
        </>
    );
};

export const getServerSideProps = async (ctx) => {

    try {
        const auth = ctx.req.cookies.AUTH;

        const bondFeatureFlag = await getOpenConfigurations(
            configurationEntityTypes.BOND_DIRECTORY_FEATURE
        );

        if (bondFeatureFlag?.entity?.[0]?.value !== 'true') {
            return {
                notFound: true,
            };
        }
        const isin = ctx?.params?.isin?.toUpperCase();

        const isValidIsin = isinRegexPattern.test(isin);

        if (!isValidIsin) {
            return {
                notFound: true,
            };
        }

        const bondDetails = await getBondDetailsById(isin, ctx);

        if (!isValidResponseEntity(bondDetails)) {
            return {
                redirect: {
                    permanent: false,
                    destination: `${routes.bonds.base}?error=${texts?.invalidIsin}`,
                },
            };
        }
        if (
            !(await isUnauthorizedRequest(auth, ctx)) &&
            bondDetails?.entity?.opportunityId
        ) {
            return {
                redirect: {
                    destination: `/opportunity/${bondDetails.entity.opportunityId}`,
                },
            };
        }

        return {
            props: {
                isin,
                bondDetails: formatBondDetails(bondDetails?.entity, isin),
            },
        };
    } catch (error) {
        return {
            props: {
                homepageDealsResponse: {
                    entity: [],
                    status: false,
                    message: 'Something went wrong',
                },
            },
        };
    }
};

export default BondDetailsPage;
